module.exports = __webpack_public_path__ + "files/8e15bdcf02cf9c061cd7bc07ede62acf.png";